import { useMemo } from "react"

import { useAuth } from "@trueskin-web/context"
import { getCountry } from "@trueskin-web/locales"
import { storageService, vwoService } from "@trueskin-web/services"
import { authService } from "@trueskin-web/services"

const storageKeys = storageService.getStorageKeys()

const getPreferredPreset = ({
  user,
  country,
  testPresetTypeForInitialPurchase,
  tofuToCorePreferredPreset,
  hasAntiAgingGoalChosen,
}) => {
  const {
    userType,
    subscription,
    preferredPresetForInitialPurchase,
    preferredPresetForRepurchase,
  } = user

  if (subscription && preferredPresetForRepurchase?.preset) {
    return preferredPresetForRepurchase.preset
  }

  if (testPresetTypeForInitialPurchase && country === "DE") {
    return testPresetTypeForInitialPurchase
  }

  if (tofuToCorePreferredPreset && userType === "tofu") {
    return tofuToCorePreferredPreset
  }

  return preferredPresetForInitialPurchase?.preset
}

const usePreferredPreset = () => {
  const { user = {} } = useAuth()

  const country = getCountry()

  const testPresetTypeForInitialPurchase = vwoService.getTestPresetType()
  const tofuToCorePreferredPreset = storageService.getItem({
    id: storageKeys.TOFU_TO_CORE_MAIN_PRESET_ID,
  })
  const hasAntiAgingGoalChosen = authService.hasAntiAgingGoalChosen()

  const preferredPreset = useMemo(
    () =>
      getPreferredPreset({
        user,
        country,
        testPresetTypeForInitialPurchase,
        tofuToCorePreferredPreset,
        hasAntiAgingGoalChosen,
      }),
    [
      user,
      country,
      testPresetTypeForInitialPurchase,
      tofuToCorePreferredPreset,
      hasAntiAgingGoalChosen,
    ]
  )

  return {
    preferredPreset,
  }
}

export default usePreferredPreset
